<button 
    class="flex items-center justify-center gap-2 px-4 py-2 rounded-3xl text-sm min-w-[60px] "
    [ngClass]="[
        type === types.white ? 'text-text-gray-900 bg-white border-gray-200 border btn-hover' : 'text-white bg-black',
        fullWidth ? 'w-full' : '',
        classes || '',
        disabled ? 'cursor-auto' : 'cursor-pointer'
    ]"
>
    <img [src]="assetUrl + 'icons/' + icon + '.svg'" alt="icon" [width]="size" [height]="size" />
    <span [ngClass]="[
        type === types.white ? 'text-gray-900 ' : 'text-white',
        hideTextOnMobile ? 'hidden sm:flex' : 'flex'
    ]">{{ value }}</span>
</button>